import { render, staticRenderFns } from "./TableAnalyticsPage.vue?vue&type=template&id=4550196c&"
import script from "./TableAnalyticsPage.vue?vue&type=script&lang=js&"
export * from "./TableAnalyticsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports